import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';

export default function Comments() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [body, setBody] = useState('');
  const [parent, setParent] = useState(null);

  const load = () => api.get('/comments').then(r => setItems(r.data));
  useEffect(() => { load(); }, []);

  const send = async () => {
    if (!body.trim()) return;
    if (!user) { toast.error('Inicia sesión para participar'); return; }
    await api.post('/comments', { body, parent_id: parent });
    setBody(''); setParent(null);
    load();
  };

  const top = items.filter(i => !i.parent_id);
  const replies = (id) => items.filter(i => i.parent_id === id);

  return (
    <main className="bg-stilo-bg" data-testid="comments-page">
      <div className="max-w-3xl mx-auto px-6 lg:px-12 pt-16 pb-32">
        <p className="overline">Conversaciones</p>
        <h1 className="font-serif text-6xl leading-[0.95] mt-4">Pregunta. Respondo.</h1>
        <p className="mt-4 text-stilo-ink2">Espacio público para dudas rápidas, opiniones de la comunidad y respuestas del estudio.</p>

        <div className="mt-12 border border-stilo-ink/10 bg-white p-6">
          {parent && <p className="overline mb-2">Respondiendo a un comentario · <button className="text-stilo-terra" onClick={()=>setParent(null)}>cancelar</button></p>}
          <textarea value={body} onChange={e=>setBody(e.target.value)} rows={3} placeholder={user ? 'Escribe tu pregunta o comentario…' : 'Inicia sesión para escribir'} disabled={!user}
            className="w-full border border-stilo-ink/15 p-3 bg-stilo-bg resize-none focus:outline-none focus:border-stilo-ink disabled:opacity-60" data-testid="comment-input" />
          <div className="mt-3 flex justify-end">
            <button onClick={send} disabled={!user} className="btn-stilo disabled:opacity-50" data-testid="comment-send">Publicar</button>
          </div>
        </div>

        <div className="mt-12 space-y-8">
          {top.length === 0 && <p className="text-stilo-ink3">Sin comentarios todavía. Sé el primero.</p>}
          {top.map(c => (
            <div key={c.id} className="border-t border-stilo-ink/10 pt-6" data-testid={`comment-${c.id}`}>
              <div className="flex justify-between items-baseline">
                <p className="font-serif text-xl">{c.author_name} {c.author_role === 'designer' && <span className="overline ml-2 text-stilo-terra">Studio Stilo</span>}</p>
                <span className="text-xs text-stilo-ink3">{new Date(c.created_at).toLocaleDateString('es-ES')}</span>
              </div>
              <p className="mt-3 text-stilo-ink leading-relaxed whitespace-pre-wrap">{c.body}</p>
              <button className="text-xs text-stilo-ink2 mt-3 hover:text-stilo-ink" onClick={()=>setParent(c.id)}>Responder ↩</button>

              <div className="mt-4 ml-6 space-y-4">
                {replies(c.id).map(r => (
                  <div key={r.id} className="border-l border-stilo-ink/15 pl-4">
                    <p className="font-serif text-lg">{r.author_name} {r.author_role === 'designer' && <span className="overline ml-2 text-stilo-terra">Studio Stilo</span>}</p>
                    <p className="mt-1 text-stilo-ink2 text-sm leading-relaxed whitespace-pre-wrap">{r.body}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
}
